import PermissionButton from '../../permissions/PermissionButton';
import React, { useEffect } from 'react';
import { Select, Form, Input, Button, Card, Typography, Row, Col } from 'antd';
import { usePaymentModes, useDeliveryModes } from '../../hooks/listsHooks';
import { useFetchAllEntrepots } from '../../hooks/entrepotHooks';

const { Option } = Select;
const { Title } = Typography;

const DevisUpdateForm = ({ initialData, onFinishedUpdate }) => {
  const [form] = Form.useForm();
  const { entrepots, loading: loadingEntrepots } = useFetchAllEntrepots();
  const { modes: paymentModes } = usePaymentModes();
  const { modes: deliveryModes } = useDeliveryModes();

  useEffect(() => {
    form.setFieldsValue({
      REMARQUE: initialData?.REMARQUE,
      MODELIV: initialData?.MODELIV,
      MODE_PAIE: initialData?.MODE_PAIE,
      NOTES: initialData?.NOTES,
      CODE_ENT: initialData?.CODE_ENT
    });
  }, [initialData, form]);

  const onFinish = (values) => {
    onFinishedUpdate(values);
  };

  return (
    <Card bordered={false} style={{ maxWidth: 800 }}>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item name="REMARQUE" label="Remarque">
          <Input />
        </Form.Item>
        <Form.Item label="Mode of Delivery" name="MODELIV">
          <Select placeholder="Select a delivery mode">
            {deliveryModes.map(mode => (
              <Option key={mode} value={mode}>{mode}</Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Payment Mode" name="MODE_PAIE">
          <Select placeholder="Select a payment mode">
            {paymentModes.map(mode => (
              <Option key={mode} value={mode}>{mode}</Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="NOTES" label="Notes">
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item label="Entrepôt" name="CODE_ENT">
          <Select 
            placeholder="Sélectionner un entrepôt"
            loading={loadingEntrepots}
            allowClear
          >
            {entrepots?.map(entrepot => (
              <Option key={entrepot.code_ent} value={entrepot.code_ent}>
                {entrepot.code_ent} - {entrepot.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Row justify="end">
          <Col>
            <PermissionButton permissionModule="quotes" permissionAction="update" type="primary" htmlType="submit">
              Update Devis
            </PermissionButton>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};

export default DevisUpdateForm;